<p-toast [style]="{marginTop: '41vh'}" position="top-center" key="cobmuldepcli"></p-toast>
<p-confirmDialog [transitionOptions]="'0ms'" key="cobmuldepcliConf" title="Confirmar Acción" appendTo="body">
</p-confirmDialog>

<div class="p-grid" style="width: 98%">
	<div class="p-col-12">
		<app-invmaebarra [botonNuevo]="botonNuevo" [botonGuardar]="botonGuardar" [botonRegresar]="botonRegresar"
			[botonBorrar]="botonBorrar" (signal)="manejarSenales($event)" [botonAnterior]="botonAnterior"
			[botonPrimero]="botonPrimero" [botonUltimo]="botonUltimo" [botonSiguiente]="botonSiguiente"
			[barraBotones3Alt]="false" [barraBotones3]="true" [barraBotonesAsiCon]="false" [botonBinocular]="true"
			[botonBuscar]="false"   [botonAlmacenardoc]="false">
		</app-invmaebarra>
	</div>
</div>

<div class="p-col-12">
	<p-tabView [(activeIndex)]="activeIndex" (onChange)="changeTabs()">
		<p-tabPanel header="Datos Generales">
			<div class="contorno" id="contorno">
				<div class="divgrups">
					<div class="p-grid">
						<div class="p-col-12">
							<div class="p-grid">
								<div class="p-col-1">
									<span>Comprobante:</span>
								</div>
								<div class="p-col-2">
									<input type="text" id="ENCCOB_COMPROBANTE" (keydown.enter)="cambiarFoco($event)"
										(input)="cambio($event)"[disabled]="!nuevoreg"
										[(ngModel)]="cxcmulticobdepcliService.cxcenccobmulti[indicador].ENCCOB_COMPROBANTE"
										pInputText style="width: 100%" autocomplete="off">
								</div>
								<div class="p-col-1">
									<span>Fecha:</span>
								</div>
								<div class="p-col-1">
									<p-calendar id="ENCCOB_FECHAEMISION"  [inputStyle]="{'width': '100%'}" dateFormat="dd/mm/yy"
										(ngModelChange)="cambio($event)" [readonlyInput]="false"
										[(ngModel)]="cxcmulticobdepcliService.cxcenccobmulti[indicador].ENCCOB_FECHAEMISION">
									</p-calendar>
								</div>
								<div class="p-col-1"></div>
								<div class="p-col-1">
									<input type="text" id="ENCCOB_CODIGO" [disabled]="true"
										
										[(ngModel)]="cxcmulticobdepcliService.cxcenccobmulti[indicador].ENCCOB_CODIGO"
										pInputText style="width: 100%" autocomplete="off">
									
								</div>
							</div>
						</div>
						<div class="p-col-12" style="margin-top: -17px">
							<div class="p-grid">
								<div class="p-col-1">
									<span>Vendedor:</span>
								</div>
								<div class="p-col-2">
									<input type="text" pInputText style="width: 100%" id="VEN_CODIGO"
										(keydown.enter)="cambiarFoco($event)" (input)="cambio($event)"
										[(ngModel)]="cxcmulticobdepcliService.cxcenccobmulti[indicador].VEN_CODIGO"
										autocomplete="off">
								</div>
								<div class="p-col-1">
									<button type="button"
										style="background-image: url(../../../assets/images/iconos/buscar.webp);"
										(click)="busquedavendedor(cxcmulticobdepcliService.cxcenccobmulti[indicador].VEN_CODIGO)"></button>
								</div>
								<div class="p-col-3">
									<span
										style="width: 100%;">{{cxcmulticobdepcliService.cxcenccobmulti[indicador].VEN_NOMBRE}}</span>
								</div>
							</div>
						</div>
						<div class="p-col-12" style="margin-top: -17px">
							<div class="p-grid">
								<div class="p-col-1">
									<span>Concepto:</span>
								</div>
								<div class="p-col-11">
									<input type="text" id="ENCCOB_CONCEPTO" (keydown.enter)="cambiarFoco($event)"
										(input)="cambio($event)" pInputText style="width: 100%"
										[(ngModel)]="cxcmulticobdepcliService.cxcenccobmulti[indicador].ENCCOB_CONCEPTO"
										autocomplete="off">
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="divgrups">
					<div class="p-grid">
						<div class="p-col-1">
							<span>Desde:</span>
						</div>
						<div class="p-col-1">
							<p-calendar id="DESDE" [inputStyle]="{'width': '100%'}" dateFormat="dd/mm/yy"
								(ngModelChange)="cambio($event)" [readonlyInput]="false" [disabled]="!nuevoreg"
								[(ngModel)]="datedesde">
							</p-calendar>
						</div>
						<div class="p-col-1"></div>
						<div class="p-col-1">
							<span>Hasta:</span>
						</div>
						<div class="p-col-1">
							<p-calendar id="HASTA" [inputStyle]="{'width': '100%'}" dateFormat="dd/mm/yy"
								(ngModelChange)="cambio($event)" [readonlyInput]="false" [disabled]="!nuevoreg"
								[(ngModel)]="datehasta">
							</p-calendar>
						</div>
						<div class="p-col-4">
							<button class="aceptar" pButton (click)="consultardocs()" [disabled]="!nuevoreg"
								style="background-image: url(../../../assets/images/iconos/btnAceptar.webp); line-height: 2.5em; font-family: Arial, serif; margin-top: -5px; margin-left: 25px">
								Aceptar
							</button>
						</div>
						<div class="p-col-2">
							<!-- <p-checkbox binary="true" label="Seleccionar Todos" [(ngModel)]="selectAll" [disabled]="!nuevoreg"
								(click)="seleccionarTodos()"></p-checkbox> -->
						</div>
					</div>
				</div>
			</div>
			<div class="p-grid">
				<div class="divgrups3">
					<div class="p col-12">
						<div class="p-grid">
							<div class="p-col-12">
								<p-tabView [(activeIndex)]="indiceTablas" (activeIndexChange)="actualizarTablas()">
									<p-tabPanel header="Documentos">
										<app-aggridsaci [width]="" [height]="'430'" [enableFilter]="true"
											[rowData]="cxcmulticobdepcliService.cxcdetcobmulti[indicador]"
											[frameworkComponents]="frameworkComponents" [animateRows]="true"
											[rowSelection]="rowSelection" [columnDefs]="columDefcxcobmulti"
											[defaultColDef]="defaultColDefcxccobmulti" [rowStyle]="rowStyle"
											[singleClickEdit]="false" [botones]="false" [mostrarGuardar]="false"
											(selected)="seleccionDocumento($event)" (cambios)="cambio($event)"
											[suppressCellSelection]="editarCeldas"></app-aggridsaci>

                                    </p-tabPanel>
                                    <p-tabPanel header="Resumen">

                                        <!-- <app-aggridsaci [width]="" [height]="largo" [enableFilter]="true"
                                        [rowData]="cxcrescobmuldepcli"
                                        [frameworkComponents]="frameworkComponents" [animateRows]="true"
                                        [rowSelection]="rowSelection" [columnDefs]="columDefCxcrescobmulti"
                                        [defaultColDef]="defaultColDefrescxccobmulti" [rowStyle]="rowStyle"
                                        [singleClickEdit]="false" [botones]="false" [mostrarGuardar]="false"
                                        (selected)="seleccionDocumento($event)" 
                                        [suppressCellSelection]="editarCeldas"></app-aggridsaci> -->

                                        <app-aggridsaci [width]="" [height]="'430'" [enableSorting]="false" [enableFilter]="true" [rowData]="cxcrescobmuldepcli"
                                        [frameworkComponents]="frameworkComponents" [animateRows]="true" [rowSelection]="rowSelection"
                                        [columnDefs]="columDefCxcrescobmulti" [defaultColDef]="defaultColDefrescxccobmulti" [rowStyle]="rowStyle"
                                        [botones]="false" [singleClickEdit]="false"></app-aggridsaci>
            
                                    </p-tabPanel>
                                    <p-tabPanel header="Anticipos">
                                        <app-aggridsaci [width]="" [height]="'430'" [enableSorting]="false" [enableFilter]="true"
                                            [rowData]="cxcanccobmuldepcli" [frameworkComponents]="frameworkComponents" [animateRows]="true"
                                            [rowSelection]="rowSelection" [columnDefs]="columnDefCxccobmultianc"
                                            [defaultColDef]="defaultColDefanccxccobmulti" [rowStyle]="rowStyle" [botones]="true" [singleClickEdit]="false"
                                            [btntraeranc]="false" [mostrarGuardar]="false" [botonesAdicionales]="false"
                                            (selected)="seleccionAncDepcli($event)"
                                            [solobotoneliminar]="true" [btncruzaranc]="false" [btngeneraab]="false"
                                            [btnreversaab]="false"
                                            ></app-aggridsaci>
                                    </p-tabPanel>
									<!-- <p-tabPanel header="Forma Pago">
										<app-aggridsaci [width]="" [height]="largo" [enableFilter]="true"
											[rowData]="cxcmulticobdepcliService.cxctrnformapagoarray[indicador]"
											[frameworkComponents]="frameworkComponents" [animateRows]="true"
											[rowSelection]="rowSelection" [columnDefs]="columDefCarteraFormaPago"
											[defaultColDef]="defaultColumnDefCarteraFormaPago" [rowStyle]="rowStyleFp"
											[singleClickEdit]="false" [botones]="btneditConcil"
											[botonesAdicionales]="true" [btnGenconcepto]="true" [btnRegComp]="true"
											[mostrarGuardar]="false" (cambios)="cambio($event)"
											(selected)="seleccionFormaPago($event)"
											[suppressCellSelection]="editarCeldas"></app-aggridsaci>
										<div class="p-grid">
											<div class="p-col-2">
												<div class="p-grid">
													<div class="p-col-4">
														<p-colorPicker [disabled]="true" [(ngModel)]="choosedColorG">
														</p-colorPicker>
													</div>
													<div class="p-col-8">
														<span>Documentos Depositados</span>
													</div>
												</div>
											</div>
											<div class="p-col-2">
												<div class="p-grid">
													<div class="p-col-4">
														<p-colorPicker [disabled]="true" [(ngModel)]="choosedColorSB">
														</p-colorPicker>
													</div>
													<div class="p-col-8">
														<span>Documentos Conciliados</span>
													</div>
												</div>
											</div>
										</div>
									</p-tabPanel>
									<p-tabPanel header="Varios">
										<app-aggridsaci [width]="" [height]="largo" [enableFilter]="true"
											[rowData]="cxcmulticobdepcliService.cxctrnvariosarray[indicador]"
											[frameworkComponents]="frameworkComponents" [animateRows]="true"
											[rowSelection]="rowSelection" [columnDefs]="columDefCarteraVarios"
											[defaultColDef]="defaultColumnDefCarteraVarios" [rowStyle]="rowStyle"
											[singleClickEdit]="false" [botones]="true" [mostrarGuardar]="false"
											(selected)="seleccionVarios($event)" (cambios)="cambio($event)"
											[suppressCellSelection]="editarCeldas"></app-aggridsaci>
									</p-tabPanel> -->
								</p-tabView>
								<div class="divgrupstabla">
									<div class="p-grid">

										<div class="p-col-12" style="margin-top: -10px;">
											<div class="p-grid">
												<div class="p-col-6"></div>
												<div class="p-col-2">
													<!-- <span class="obligatorio">Total deuda</span> -->
												</div>				
												<div class="p-col-2">
													<span class="obligatorio">Total doc seleccionados</span>
												</div>
												<div class="p-col-2">
													<span class="obligatorio">Total forma de pago-cruzado</span>
												</div>
											</div>
										</div>
										<div class="p-col-12" style="margin-top: -15px; margin-bottom: -15px">
											<div class="p-grid">
												<div class="p-col-6"></div>
												<div class="p-col-2">
													<!-- <input type="text" class="totales" pInputText
														[(ngModel)]="cxcmulticobdepcliService.cxcenccobmulti[indicador].TOTALDEUDA"
														[disabled]="true" autocomplete="off"> -->
												</div>
												<div class="p-col-2">
													<input type="text" class="totales" pInputText
														[(ngModel)]="cxcmulticobdepcliService.cxcenccobmulti[indicador].ENCCOB_IMPORTE"
														[disabled]="true" autocomplete="off">
												</div>
												<div class="p-col-2">
													<input type="text" class="totales" pInputText
														[(ngModel)]="cxcmulticobdepcliService.cxcenccobmulti[indicador].TOTALVAR"
														[disabled]="true" autocomplete="off">
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

		</p-tabPanel>
	</p-tabView>
</div>

<p-dialog header="Búsqueda de Datos" [(visible)]="displayDialogBusquedaFast" [transitionOptions]="'0ms'" [modal]="true"
	appendTo="body" [style]="{width: '70vw', height: '70vh'} ">
	<app-busquedadlg [arrayOptions]="types" [arregloConsulta]="arregloCons" [tabla]="tabla" [where]="where"
		[busquedaParams]="busquedacampos" (opcionSeleccionada)="manejarSeleccion($event)"></app-busquedadlg>
</p-dialog>

<div style=" 	position: fixed;
				z-index: 999;
				height: 2em;
				width: 2em;
				overflow: visible;
				margin: auto;
				top: 0;
				left: 0;
				bottom: 0;
				right: 0;

				">
    <p-progressSpinner *ngIf="spin" [style]="{width: '100px', height: '100px'}" animationDuration=".5s">
    </p-progressSpinner>
    <p-dialog [(visible)]="spin" [transitionOptions]="'0ms'" [modal]="true" [closable]="false"
        [style]="{ opacity: 0.00}" position="top">
    </p-dialog>
</div>